
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./index.jsx") })
        }
      }, "page-component---src-pages-index-jsx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=page-component---src-pages-index-jsx!./src/pages/index.jsx
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=page-component---src-pages-index-jsx!./src/pages/index.jsx
// module chunks = 15178676390636814000